import { createSelector } from 'reselect'

// Base selectors
const getInboxState = state => state.inbox || {}

const getEmailsState = createSelector(
  getInboxState,
  inbox => inbox.emails || {}
)

const getStatsState = createSelector(
  getInboxState,
  inbox => inbox.stats || {}
)

const getEmailDetailState = createSelector(
  getInboxState,
  inbox => inbox.emailDetail || {}
)

const getActionsState = createSelector(
  getInboxState,
  inbox => inbox.actions || {}
)

// Email selectors
export const getEmails = createSelector(
  getEmailsState,
  emails => emails.items || []
)

export const getEmailsMeta = createSelector(
  getEmailsState,
  emails => emails.meta || {}
)

export const getEmailsLoading = createSelector(
  getEmailsState,
  emails => emails.loading || false
)

export const getEmailsError = createSelector(
  getEmailsState,
  emails => emails.error
)

export const getHasNextPage = createSelector(
  getEmailsMeta,
  meta => meta.currentPage < meta.lastPage
)

// Email detail selectors
export const getSelectedEmailDetail = createSelector(
  getEmailDetailState,
  emailDetail => emailDetail.data
)

export const getEmailDetailLoading = createSelector(
  getEmailDetailState,
  emailDetail => emailDetail.loading || false
)

export const getEmailDetailError = createSelector(
  getEmailDetailState,
  emailDetail => emailDetail.error
)

// Stats selectors
export const getInboxStats = createSelector(
  getStatsState,
  stats => stats.data || {}
)

export const getStatsLoading = createSelector(
  getStatsState,
  stats => stats.loading || false
)

export const getStatsError = createSelector(
  getStatsState,
  stats => stats.error
)

// Action selectors
export const getMarkingAsReadStatus = createSelector(
  getActionsState,
  actions => actions.markingAsRead || {}
)

export const getRetryingAttachmentsStatus = createSelector(
  getActionsState,
  actions => actions.retryingAttachments || {}
)

export const getRetryingAttachmentStatus = createSelector(
  getActionsState,
  actions => actions.retryingAttachment || {}
)

// Computed selectors
export const getUnreadEmails = createSelector(
  getEmails,
  emails => emails.filter(email => !email.isReadByMe)
)

export const getUnreadCount = createSelector(
  getUnreadEmails,
  unreadEmails => unreadEmails.length
)

export const getEmailsWithFailedAttachments = createSelector(
  getEmails,
  emails => emails.filter(email => 
    email.attachmentProcessingStatus?.hasFailures
  )
)

export const getTotalFailedAttachments = createSelector(
  getEmailsWithFailedAttachments,
  emailsWithFailures => emailsWithFailures.reduce(
    (total, email) => total + (email.attachmentProcessingStatus?.failed || 0),
    0
  )
)